import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { Input } from 'shared/components/Input';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { form, FormProps } from 'shared/utils/form';
import SubmitButton from 'shared/components/SubmitButton';
import { validate } from 'shared/utils/validators';
import { constraints, FormData } from './constraints';
import { routine } from './actions';
import { CodeSource } from '../../types';

import './index.scss';

export interface Props {
  codeSource: CodeSource;
}

type Enhanced = Props & InjectedTranslateProps & FormProps<FormData, Props>;
const b = b_.with('code-form');

const enhance = compose<Enhanced, Props>(
  translate,
  form<FormData, Props>(routine, {
    form: 'signUpCode',
    validate: (values) => validate(constraints, values),
  })
);

const digits = (value: string) => value.replace(/[^\d]/g, '');

const Code: React.FC<Enhanced> = ({ t, formSubmit, submitting, error, codeSource }) => (
  <form onSubmit={formSubmit} method="POST" data-testid="signin-popup-code-step">
    <div>
      <Input
        name="code"
        classNameLabel={b('input-label')}
        label={t('Code')}
        autoFocus
        normalize={digits}
        tooltipPlacement="bottomLeftSticky"
      />
    </div>
    <p className={b('notice')}>
      {codeSource === 'email'
        ? t('Code was sent to email Please enter')
        : t('Please enter code from Google Authenticator')}
    </p>
    <div className={b('buttons')}>
      <SubmitButton className={b('btn')} primary submitting={submitting} error={error}>
        {t('Sign in')}
      </SubmitButton>
    </div>
  </form>
);

export default enhance(Code);
